import { render, staticRenderFns } from "./Preview.vue?vue&type=template&id=25ff27f4&scoped=true"
import script from "./Preview.vue?vue&type=script&lang=ts&setup=true"
export * from "./Preview.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Preview.vue?vue&type=style&index=0&id=25ff27f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ff27f4",
  null
  
)

export default component.exports